module.exports = __webpack_public_path__ + "img/HZGB02-02-06.f8359d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/HZGB02-02-06.png
// module id = 1Zb+
// module chunks = 0